<template>
  <div style="margin: 0px; padding: 0px;">
    <el-container direction="vertical" class="layout-container">
    <HEAD :active="active"></HEAD>
      <el-main class="el-main-ms">
        <!--图片层-->
        <main-plugin :img-src="imgSrc"></main-plugin>
        <!--加盟流程。加盟服务-->
        <j-mflow-plugin></j-mflow-plugin>
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
    <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import MainPlugin from "@/components/MainPlugin";
import JMflowPlugin from "@/components/JMflowPlugin";
import ContactPlugin from "@/components/ContactPlugin";
export default {
  name: "Cooperate",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '陌上酒店合作攻略'
    },{
      name: 'description',
      content: '加盟流程：链接陌上、联系我们、项目勘察、签署合同、筹建酒店、酒店开业。加盟服务：营销支持、流量支持、培训支持、质检支持、财务支持、设计支持、工程支持、集采支持、项目评估、金融支持。'
    }]
  },
  data() {
    return {
      active: '5',
      imgSrc: require('../assets/images/01-05-1440-560.png')
    }
  },
  components: {
    HEAD,
    FOOT,
    MainPlugin,
    JMflowPlugin,
    ContactPlugin
  }
}
</script>

<style scoped>

</style>
